import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["FormControl", "showLabel", "children"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const RuleBox = props => {
  const {
      FormControl: FormControlComponent = FormControl,
      showLabel = false,
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(View, {
    marginBlock: "400",
    children: /*#__PURE__*/_jsx(FormControlComponent, Object.assign({
      label: showLabel ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.routingRules.options.usersAndTeams"
      }) : null
    }, rest, {
      children: children
    }))
  });
};
RuleBox.displayName = 'RuleBox';
export default RuleBox;